<template>
  <div v-if="$route.name == 'Data Dokter'">
    <b-row class="animated fadeIn">
      <b-col sm="6" lg="4">
        <b-card :no-body="true" class="hover" @click="tambahData">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-medkit bg-info p-4 font-2xl mr-3 float-left"></i>
            <div class="h5 text-info mb-0 pt-3">Tambah Data</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Dokter</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="4">
        <b-card :no-body="true" class="hover" v:onClick="tambahData()">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-file-excel-o bg-success p-4 font-2xl mr-3 float-left"></i>
            <div class="h5 text-info mb-0 pt-3">Export Data</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">ke Excel</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="4">
        <b-card :no-body="true" class="hover" v:onClick="tambahData()">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-file-pdf-o bg-warning p-4 font-2xl mr-3 float-left"></i>
            <div class="h5 text-info mb-0 pt-3">Export Data</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">ke PDF</div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="12" lg="12">
        <b-card>
          <div slot="header" v-if="this.$store.state.level == 1">
            <b-form-select class="col-sm-12" :plain="true" :options="listCabang" v-model="id_cabang"></b-form-select><br>
          </div>

          <div slot="header">
            <b-input-group left="<i class='fa fa-search'></i>">
              <b-form-input @keyup.native="cari()" v-model="search" type="text" placeholder="Cari data dokter. Ketik apapun disini. (Cth: Kode Dokter, Nama Dokter, No Batch, Expire Date, dsb)"></b-form-input>
            </b-input-group>
          </div>

          <table class="table">
            <tr>
              <th>No</th>
              <th v-if="$store.state.level == 1">Cabang</th>
              <th>Kode Dokter</th>
              <th>Nama Dokter</th>
              <th>No Telp</th>
              <th>No SIP</th>
              <th>Email</th>
              <th>Action</th>
            </tr>

            <tr v-if="isLoading" class="animated fadeIn">
              <td colspan="6">
                <p class="text-center"><i class="fa fa-spinner fa-spin"></i> Loading Data</p>
              </td>
            </tr>

            <tr v-else-if="dokter.total_result > 0" v-for="(item, index) in dokter.result" class="animated fadeIn">
              <td>{{ index+1 }}</td>
              <td v-if="$store.state.level == 1">{{ item.cabang ? item.cabang.nama_cabang : '-' }}</td>
              <td>{{ item.kode_dokter }}</td>
              <td>{{ item.nama_dokter }}</td>
              <td>{{ item.no_telp}}</td>
              <td>{{ item.no_sip }}</td>
              <td>{{ item.email }}</td>
              <td>
                <b-btn :to="'dokter/edit/' + item.kode_dokter" type="button" class="btn btn-sm btn-outline-warning"><i class="fa fa-pencil"></i></b-btn>
                <button v-on:click="destroy(item.id)" type="button" class="btn btn-sm btn-outline-danger"><i class="fa fa-trash"></i></button>
              </td>
            </tr>

            <tr v-else>
              <td colspan="6">
                <p class="text-center">Data tidak ditemukan</p>
              </td>
            </tr>
          </table>

          <b-pagination :total-rows="dokter.total_result" :per-page="dokter.per_page" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </b-card>
      </b-col>
    </b-row>
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Dokter from '@/model/Dokter'
  import moment from 'vue-moment'
  import Cabang from '@/model/Cabang'

  Vue.use(moment)

  var timer

  export default {
    watch: {
      '$route' (to, from) {
        if (to.path === '/master/dokter') {
          this.getData()
        }
      },
      currentPage (e) {
        this.getData()
      },
      id_cabang (e) {
        this.getData()
      }
    },
    data: () => {
      return {
        isLoading: true,
        currentPage: 1,
        search: '',
        dokter: {},
        listCabang: [],
        id_cabang: ''
      }
    },
    methods: {
      tambahData () {
        this.$router.push({ path: '/master/dokter/tambah' })
      },
      async getData () {
        try {
          var params = []
          params.search = this.search

          if (this.id_cabang != 0) params.id_cabang = this.id_cabang

          this.isLoading = true
          const dokter = await Dokter.getDokter(params)
          this.dokter = dokter.data
          this.isLoading = false
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
      },
      destroy (id) {
        this.$swal({
          title: 'Konfirmasi',
          text: 'Anda yakin ingin menghapus data dokter ini?',
          icon: 'warning',
          buttons: true,
          dangerMode: true
        }).then(result => {
          if (result) this.delete(id)
        })
      },
      async delete (id) {
        try {
          const dokter = await Dokter.deleteDokter(id)
          this.dokter = dokter.data.result
          this.$toastr.s('Hapus data dokter berhasil')
          this.getData()
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
      },
      cari () {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => this.getData(), 400)
      }
    },
    async mounted () {
      if (this.$route.path === '/master/dokter') {
        this.getData()
      }

      this.listCabang = []
      this.listCabang.push({
        text: 'Semua Cabang',
        value: ''
      })

      var el = this.listCabang
      var cabang = await Cabang.getCabangList()
      cabang.data.forEach(function (e, i) {
        el.push({
          text: e.label,
          value: e.value
        })
      })
    }
  }
</script>
